import { render, staticRenderFns } from "./PowerRecordMore.vue?vue&type=template&id=7832bf1d&scoped=true&"
import script from "./PowerRecordMore.vue?vue&type=script&lang=js&"
export * from "./PowerRecordMore.vue?vue&type=script&lang=js&"
import style0 from "./PowerRecordMore.vue?vue&type=style&index=0&id=7832bf1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7832bf1d",
  null
  
)

export default component.exports